import { TJsonQueryKey, ERentTime } from '../../../../JsonQuery';

export const COMMON_PROPERTIES: TJsonQueryKey[] = [
  '_type',
  'bedroom_total',
  'bs_center',
  'building_status',
  'category',
  'currency',
  'engine_version',
  'for_day',
  'from_developer',
  'geo',
  'kp_id',
  'object_type',
  'office_type',
  'price',
  'price_sm',
  'region',
  'room',
  'site',
  'suburban_offer_filter',
  'with_newobject',
];

export const RENTAL_PERIOD_SELECTED_OPTIONS = [ERentTime.FromYear, ERentTime.FewMonths];
